import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import instance from "../../../config/Config";

const initialState = {
    data: null,
    loading: false,
    error: null,
    count: null,
    analytics: null,
    downloader: null,
    hourly: null
};

export const getResumeDownloadList = createAsyncThunk(
    "getResumeDownloadList",
    async (body) => {
        try {
            const response = await instance.get(
                `remark/timerresume/get-all-timer-resume-downloader?page=${body.page}&search=${body.search}&startDate=${body.startDate}&endDate=${body.endDate}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }
);

export const getAnalyticsList = createAsyncThunk(
    "getAnalyticsList",
    async (body) => {
        try {
            const response = await instance.get(
                `remark/timerresume/get-all-analytics`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }
);

export const getDownloaderList = createAsyncThunk(
    "getDownloaderList",
    async (filter) => {
        try {
            const response = await instance.get(
                `remark/timerresume/get-top-downloader?filter=${filter}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }
);

export const getDownloadHourly = createAsyncThunk(
    "getDownloadHourly",
    async () => {
        try {
            const response = await instance.get(
                `remark/timerresume/get-top-downloader-hourly`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }
);




export const ResumeDownloadTimerSlice = createSlice({
    name: "ResumeDownloadTimerSlice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getResumeDownloadList.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(getResumeDownloadList.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            state.count = action.payload?.count;
        });
        builder.addCase(getResumeDownloadList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
        builder.addCase(getAnalyticsList.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(getAnalyticsList.fulfilled, (state, action) => {
            state.loading = false;
            state.analytics = action.payload;
        });
        builder.addCase(getAnalyticsList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        builder.addCase(getDownloaderList.pending, (state, action) => {
            state.loading = false;
        });
        builder.addCase(getDownloaderList.fulfilled, (state, action) => {
            state.loading = false;
            state.downloader = action.payload;
        });
        builder.addCase(getDownloaderList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        builder.addCase(getDownloadHourly.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(getDownloadHourly.fulfilled, (state, action) => {
            state.loading = false;
            state.hourly = action.payload;
        });
        builder.addCase(getDownloadHourly.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    },
});

export default ResumeDownloadTimerSlice.reducer;
